
<div class=" scrollable">

  <div class="country" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20
,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,
61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,
101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120
,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,
141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,
161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,
184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211] ">
    <div class="row hov  " *ngFor="let c of caseees"  >
      <div class="col-md-2">
        <img src= {{c[i].countryInfo.flag}} height="30px" width="43px" style="border-radius: 4px;">
      </div>
      <div class="col-md-4 casess animated bounceInUp delay-1s" >{{c[i].country }}</div>
      <div class="col-md-6 casees count" style="color: black; padding-left: 25px;">{{c[i].cases  |  number: "1.0" }}</div>
      <br>
      <div class="col-md-12 cases">
        <div class="row">
          <div class="col-md-6">Recovery : </div>
          <div class="col-md-6 count"  style="color: green;padding-left: 25px;">{{c[i].recovered   |  number: "1.0" }}</div>
        </div>
        <div class="row">
          <div class="col-md-6">Deaths :
		    <!---<span CountTo="100"  duration="0.1">0</span>-->
		  </div>
          <div class="col-md-6 count" style="color: red;padding-left: 25px;"> {{c[i].deaths  |  number: "1.0" }}</div>
        </div>
        <hr>
      </div>
      <hr>
      <br>
    </div>
  </div>
</div>
<br>
<hr>
<br>

<!--
<div class="container-fluid ">
  <div class="search-box">
    <h5 style="text-align:center">Search</h5>
    <div class="row">

      <div class="col-md-12">
        <input type="text" id="myInput"  [(ngModel)]="values" (keyup.enter)="seraching(values)" class="form-control" placeholder="Your country name">

      </div>
    </div>
  </div>
  <div class="search-list" *ngIf="values">
    <h6>Votre historique de recherche</h6>
    <table class="table" id="myTable" *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10]">
      <thead>
        <tr>
          <th style="color: black;">{{cy[i].totalcases}}</th>
          <th>{{cy[i].country}}</th>
        </tr>
        <tr>
          <th style="color: green;">{{cy[i].recovered}}</th>
        </tr>
        <tr>
          <th style="color: red;">{{cy[i].totaldeaths}}</th>
        </tr>
      </thead>

    </table>
<br>
  </div>
</div> -->
